import React from "react";

import {useSiteConfig} from "@globals/SiteConfig";
import {useUser} from "@globals/user";

import {AccessRightFlags, CheckAccess} from "@components/CheckAccess";
import MaxWidthContainer from "@components/layout/MaxWidthContainer";

import SamlConfigurationForm from "./SamlConfigurationForm";
import styles from "./index.scss";

const SamlConfigurationApp = (): JSX.Element => {
  const domain: string = window.location.host;
  const {user} = useUser();
  const {isMainEatclubSite} = useSiteConfig();

  return (
    <MaxWidthContainer className={styles.container} tagName="main">
      <h2>SAML Configuration</h2>
      <CheckAccess
        flag={AccessRightFlags.IsMasterAccountHolder}
        fallback="You don't have access to this page."
      >
        {isMainEatclubSite() ? (
          <p>
            If you use Okta or OneLogin then you will find the EAT Club SAML
            integration in their app stores. Please use the following settings.
          </p>
        ) : (
          <p>
            At this moment, you'll need to configure SAML yourself. Please use
            the following settings.
          </p>
        )}
        <p>
          Reply URL: <b>https://{domain}/user/sso/complete/saml/</b>
          <br />
          Identifier: <b>https://{domain}</b>
          <br />
          Provide these attributes:{" "}
          <b>first_name, last_name, email, phone_number</b>
          <br />
        </p>
        <p>
          For both methods please use your company's RelayState:{" "}
          <b>{user?.company.id}</b>
        </p>
        <p>
          Then paste your Identity Provider URL, Issuer ID and X.509 Certificate
          into the fields below.
        </p>
        <SamlConfigurationForm />
        <h3>FAQ's</h3>
        <ul>
          <li>
            We do not currently allow forcing SAML, users can always configure
            and use a password.
          </li>
          <li>
            We do not currently support logging out or account deactivation with
            SAML
          </li>
          <li>
            New accounts will be automatically created for new email addresses,
            however they will not automatically be able to order food unless
            configured with a default program above.
          </li>
        </ul>
      </CheckAccess>
    </MaxWidthContainer>
  );
};

export default SamlConfigurationApp;
